import { Input, Output, EventEmitter, Component, ViewChild, OnInit } from '@angular/core';
import { BbSelectOption } from './../../shared/bb-select/bb-select.component';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LiveRestream } from '../../../interfaces/live';
import { LiveApiService } from '../../../services/live-api.service';

@Component({
	selector: 'restream-quickedit',
	templateUrl: './restream-quickedit.component.html',
	styleUrls: ['./restream-quickedit.component.scss']
})

export class RestreamQuickeditComponent implements OnInit {
	@ViewChild('formRef', { static: true }) form: NgForm;

	@Input() row: any;
	@Input() streamUuid: string;

	@Output() saved: EventEmitter<any> = new EventEmitter<any>();
	@Output() removed: EventEmitter<any> = new EventEmitter<any>();
	@Output() canceled: EventEmitter<any> = new EventEmitter<any>();

	label: string;
	entity: LiveRestream;
	pristineEntity: LiveRestream;

	restreamTypeOptions: BbSelectOption[];

	constructor(protected route: ActivatedRoute, protected liveApiService: LiveApiService) {

	}

	ngOnInit() {
		this.label = 'RESTREAM';
		this.restreamTypeOptions = [{ value: 'rtmp', label: 'RTMP', default: true }];

		this.entity = this.row;
		this.pristineEntity = this.row;
	}

	save() {
		this.liveApiService.saveRestream(this.streamUuid, this.row).subscribe(
			(res) => {
				this.row.quickEditing = false;
				this.saved.emit(true);
			}
		);
	}

	delete() {
		if (this.row.id !== 'new') {
			this.liveApiService.deleteRestream(this.streamUuid, this.row).subscribe(
				(res) => {
					this.removed.emit();
				}
			);
		} else {
			this.removed.emit();
		}
	}

	onCancelClick() {
		if (this.entity.id === 'new') {
			this.canceled.emit(true);
		} else {
			this.row.quickEditing = false;
		}
	}
}
